<div class=" flex flex-col">
  <app-header></app-header>
  <app-category></app-category>
  <app-menus></app-menus>
  <app-promos></app-promos>
  <div class="flex flex-col gap-4 w-full max-w-8xl ">
    <app-maps></app-maps>
  </div>
</div>
